var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeveloper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98095 1.9577C7.98095 3.03927 7.06032 3.91541 5.92381 3.91541C4.79365 3.90937 3.87302 3.03323 3.87302 1.9577C3.87302 0.876133 4.79365 0 5.92381 0C6.05714 0 6.19683 0.0120846 6.32381 0.0362538L5.84127 1.02115C5.82222 1.02115 5.80317 1.02115 5.77778 1.02115C5.29524 1.02115 4.90159 1.39577 4.90159 1.85498C4.90159 2.3142 5.29524 2.68882 5.77778 2.68882C6.26032 2.68882 6.65397 2.3142 6.65397 1.85498C6.65397 1.63142 6.55873 1.42598 6.40635 1.27492L6.91429 0.241692C7.54921 0.574018 7.98095 1.2145 7.98095 1.9577ZM16 8.79758H14.5206C14.8317 8.71299 15.0984 8.51964 15.2825 8.25982C15.5365 7.8852 15.5746 7.42598 15.3841 7.02115L13.8095 3.66767L13.0921 3.40786L14.0571 0.259819L13.1111 0L11.0667 6.68278L12.0127 6.9426L12.8698 4.14502L13.2127 4.26586L14.654 7.3293C14.7365 7.49849 14.7175 7.6858 14.6095 7.8429C14.5016 8 14.3302 8.09063 14.1333 8.09063H12V8.80363H10C9.98095 8.13293 9.42857 7.61329 8.74921 7.61329H6C6 7.61329 4.78095 4.56193 4.75556 4.5136C4.50159 3.87915 3.93651 3.41994 3.20635 3.41994C2.27302 3.41994 1.5619 4.1571 1.05397 5.22054C0.374603 6.64048 0.00634921 8.34441 0 10L16 9.99396V8.79758Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloper);
export default __webpack_public_path__ + "static/media/developer.b0bea3388fb56c0bfc00ffe625ac6eee.svg";
export { ForwardRef as ReactComponent };